import styled from 'styled-components'

export const Notice = styled.div`
  width: 100%;
  height: 51px;
  padding: 5px;
  display: flex;
  align-items: center;
  color: #fff;
  @media (max-width: 729px) {
    display: none;
  }
  .left {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    .text {
      font-size: 12px;
      color: #fff;
    }
  }
  .right {
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    .marquee {
      height: 25px;
      width: 100%;

      overflow: hidden;
      position: relative;
    }

    .marquee div {
      margin-top: 6px;
      display: block;
      width: 1250px;
      position: absolute;
      overflow: hidden;
      animation: marquee 15s linear infinite;
    }

    .marquee .span {
      float: left;
      width: auto;
      span {
        margin: 0 3px;
      }
      .a1 {
        color: #fe642e;
      }
      .a2 {
        color: #ffff00;
      }
      .a3 {
        color: #fe642e;
      }
      .a4 {
        color: #2e9afe;
      }
      .a5 {
        color: #fe642e;
      }
      .a6 {
        color: #9afe2e;
      }
      .a7 {
        color: #ff4000;
      }
    }

    @keyframes marquee {
      0% {
        left: 100%;
      }
      100% {
        left: -1200px;
      }
    }
  }
`